<h2 mat-dialog-title>Start Exam</h2>
<div mat-dialog-content [innerHTML]="sanitizeHtml(startExamMessage)"></div>
<mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>Cancel</button>
    <button mat-button color="primary" [mat-dialog-close]="true" cdkFocusInitial>Start</button>
</mat-dialog-actions>


<!-- Copyright 2023 Google LLC. All Rights Reserved.
    Use of this source code is governed by an MIT-style license that
    can be found in the LICENSE file at https://angular.io/license -->